// extracted by mini-css-extract-plugin
module.exports = {"routes":"FooterRoutes_routes__13RAB"};